import { Fragment } from "react";
import { Grid } from "@mui/material";

import { ComponentHeader, Label, TextField } from "../../../../components";
import FormFourth from "./CreateCampaignFouthForm";

export default function FormThird({ formikProps, editState, component }) {
  return (
    <Fragment>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Payout"}
          subtitle={
            component === ""
              ? "Choose conversion type for the campaign."
              : "Conversion type for the campaign"
          }
        />
      </Grid>

      {/* <Grid item xs={3}>
        <Label title="Minimum Budget" />

        <TextField
          required
          name="budget.value.min"
          formikProps={formikProps}
          disabled={!editState || formikProps.values.campaignStatus === "READY"}
          placeholder="Minimum budget"
        />
      </Grid>

      <Grid item xs={3}>
        <Label title="Maximum Budget" />

        <TextField
          required
          name="budget.value.max"
          formikProps={formikProps}
          disabled={!editState || formikProps.values.campaignStatus === "READY"}
          placeholder="Maximum budget"
        />
      </Grid> */}

      <FormFourth formikProps={formikProps} editState={editState} />
    </Fragment>
  );
}
